import clsx from 'clsx';
import type { ForwardedRef } from 'react';

import type { MaterialIcon } from '../../../types/icons';
import { type Size, SVG_ICON_SIZE } from '../../../types/layout';

/**
 * List of icons: https://fonts.google.com/icons?icon.set=Material+Icons
 *
 * @example
 * <Icon size="sm" icon="home" outlined />
 */

export interface SgIconProps {
  ref?: ForwardedRef<HTMLElement>;
  icon: MaterialIcon;
  // color?: Color
  size?: Size;
  outlined?: boolean;
  className?: string;
  style?: React.CSSProperties;
  'data-e2e'?: string;
}

// Icon size mapping to pixels
const getIconSize = (size: Size = 'md'): string => {
  return `${SVG_ICON_SIZE[size]}px`;
};

export const SgComponentIcon = (props: SgIconProps) => {
  const { icon, size = 'md', ref, outlined = false, 'data-e2e': dataE2e, className, style } = props;

  return (
    <i
      ref={ref}
      className={clsx(['icon', className], {
        'icon-outlined': outlined,
      })}
      style={{
        lineHeight: 1,
        minWidth: getIconSize(size),
        minHeight: getIconSize(size),
        maxHeight: getIconSize(size),
        fontSize: getIconSize(size),
        ...style,
      }}
      data-e2e={dataE2e}
    >
      {icon}
    </i>
  );
};
